module.exports = __webpack_public_path__ + "static/6-3e2a2f0eb3040fdcc311917cfb5ba9e1.png";